<template>
    <div v-if="loaded ? loaded : false">
        <div id="popContainer">
            <DxPopup v-model:visible="showPopup"  v-if="loaded"
                     container="#popContainer"
                     :drag-enabled="false"
                     :close-on-outside-click="true"
                     :show-close-button="true"
                     :show-title="true"
                     :width="700"
                     :height="250"
                     title="Error">
                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               :options="closeButtonOptions" />
                <div class="nacMessage">
                    <div class="nacMessageImg"><i class="fa-solid fa-bug"></i></div>
                    <div class="nacMessageP">
                        An error occured
                    </div>
                    <div class="nacMessageP">
                       {{ errorMessage }}
                    </div>
                </div>

            </DxPopup>
        </div>
    </div>
</template>
<script>
    import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
    export default {
        name: 'NotificationAdminVx',
        components: {
            DxPopup,
            DxToolbarItem
        },
        data() {
            return {
                showPopup: false,
                closeButtonOptions: {
                    text: 'Close',
                    onClick: () => {
                        this.showPopup = false;
                    }
                },
                loaded: false
            }
        },
        props: {
            errorMessage: {
                type: String,
                required: false,
            },
        },
        created: function () {
            this.loaded = true;
            this.showPopup = true;
        },
    }
</script>
<style scoped>
    .nacMessage {
        display: grid;
        grid-template-columns: auto auto;
        gap: 20px;
    }

    .nacMessageImg {
        color: red;
        font-size: 33px;
        grid-row-start: 1;
        grid-row-end: 3;
    }
</style>